import React from "react";
import dynamic from "next/dynamic";
import getColor from "@gcloud-npm/utils.enums.colors";
import Text from "@/bit/components/components.text";
import CustomLink from "@/bit/components/components.custom-link";
import PropTypes from "prop-types";
import Button from "@/bit/components/components.button";

const Icon = dynamic(() => import("@/bit/components/components.icon-glyph"));

const checkPropNull = (prop) => {
  return prop === null || prop === 0 || prop === "0" || prop === "";
};
/**
 * Componente que consiste en un icono, un texto y un botón (ejemplo de uso_ módulo de activación)
 */
const Alert = (props) => {
  if (!props) {
    return null;
  }

  const { cmsHandler } = props;
  const color = props.color;
  const backgroundColor = getColor(color);
  const alertText = props["cms-atom-text-1"];
  const alertLinkText = props["cms-atom-text-2"];
  const alertIcon = props["cms-atom-icon-1"];
  const alertLink = props["cms-atom-link-1"];
  const alertButton = props["cms-atom-button-1"];

  if (!cmsHandler && !(alertText?.text || alertLinkText?.text)) {
    return null;
  }

  let showIcon = true;
  if (
    !cmsHandler &&
    (alertIcon?.id === "" || checkPropNull(alertIcon?.width))
  ) {
    showIcon = false;
  }

  return (
    <section className={`cms-alert`}>
      {cmsHandler && (
        <span
          className={
            "element-editable block edit-component cms-alert-placeholder"
          }
          onClick={() =>
            cmsHandler({
              ...props,
              name: "cms-block.cms-alert",
            })
          }
        >
          <Icon id="lapiz-m" height={20} color="white" />
        </span>
      )}
      <div
        className={`cms-alert--content${
          color.toLowerCase() === "white" ? " no-padding" : ""
        }`}
        style={{ backgroundColor: backgroundColor }}
      >
        <div className="icon-text">
          {showIcon && (
            <div className="icon">
              <Icon {...alertIcon} cmsHandler={cmsHandler} />
            </div>
          )}
          <div className="only-text">
            <Text
              className="modal-legals-device"
              {...alertText}
              cmsHandler={cmsHandler}
            />
            <CustomLink {...alertLink} cmsHandler={cmsHandler}>
              <Text {...alertLinkText} cmsHandler={cmsHandler} />
            </CustomLink>
          </div>
        </div>
       {cmsHandler || (alertButton && alertButton.label) && <div className="action-button-container">
          <Button {...alertButton} cmsHandler={cmsHandler} />
        </div>}
      </div>
      <style jsx>{`.cms-alert {
  position: relative;
  .cms-alert--content {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #f5f5f5;
    border-radius: 10px;
    padding: 10px;
    position: relative;
    gap: 0.8rem;

    &.no-padding {
      padding: 10px 0;
    }
    &.justify-content-center {
      justify-content: center;
    }
    .icon-text {
      display: flex;
      align-items: center;
      gap: 6px;
      flex: 1;
      .only-text {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        gap: 4px;
      }
      .action-button-container {
        display: flex;
        margin-right: 0.5rem;
      }
    }

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    @media screen and (max-width: 1024px) {
      padding: 8px 16px;
    }
    :global(a) {
      text-decoration: none;
    }
  }
  @media screen and (max-width: 520px) {
    .cms-alert--content {
      .action-button-container {
        width: 100%;
        display: flex;
        justify-content: center;
        :global(.buttonx) {
          width: 100%;
        }
      }
      .icon-text {
        flex-direction: row;
        align-items: flex-start;
      }
    }
  }
}
`}</style>
    </section>
  );
};

Alert.propTypes = {
  /**
   * {
   *  "info": "Color de fondo",
   *  "kind": "both",
   *  "beautifulName": "Color de fondo"
   * }
   */
  color: PropTypes.string,
};

Alert.defaultProps = {
  color: "",
};

export default Alert;
